module.exports = __webpack_public_path__ + "static/media/About-bg.8e8032a7.jpg";